import { Module } from 'vuex';
import { SearchState } from '../../models';
import { RootStoreState } from '../store.interfaces';
import { SEARCH_ACTIONS } from './search.actions';
import { SEARCH_GETTERS } from './search.getters';
import { SEARCH_MUTATIONS } from './search.mutations';
import { getInitialSearchState } from './search.state';

export const SEARCH_MODULE: Module<SearchState, RootStoreState> = {
  namespaced: true,
  actions: SEARCH_ACTIONS,
  mutations: SEARCH_MUTATIONS,
  getters: SEARCH_GETTERS,
  state: getInitialSearchState()
};
